import { Link, useParams, useLocation } from "wouter";
import { getPhases } from "./registry.js";

export const Helm = () => {
  const phases = getPhases();
  const { orgSlug } = useParams<{ orgSlug: string }>();
  const [location] = useLocation();
  const isOverviewActive = location === `/o/${orgSlug}/overview`;

  return (
    <div className="grid grid-rows-[auto_auto]">
      <Link
        href={`/o/${orgSlug}/overview`}
        className={`flex justify-center rounded-none px-4 py-2 text-xs font-medium transition-all hover:bg-muted hover:text-foreground active:translate-y-px ${isOverviewActive ? "bg-muted text-foreground" : "text-foreground/60"}`}
      >
        Overview
      </Link>
      <div className="grid auto-cols-fr grid-flow-col">
        {phases.map(phase => (
          <phase.tile key={phase.type} />
        ))}
      </div>
    </div>
  );
};
